import { render, staticRenderFns } from "./SpOrdersView.vue?vue&type=template&id=37ca4e68"
import script from "./SpOrdersView.vue?vue&type=script&lang=js"
export * from "./SpOrdersView.vue?vue&type=script&lang=js"
import style0 from "./SpOrdersView.vue?vue&type=style&index=0&id=37ca4e68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports